import { createAsyncActionTypes } from '../../helpers';

const domain = 'packages';

const fetchPackageByProjectId = createAsyncActionTypes(domain, 'fetchPackageByProjectId');

const fetchPackageForProofByProjectId = createAsyncActionTypes(domain, 'fetchPackageForProofByProjectId');

const fetchPackageByCustomerId = createAsyncActionTypes(domain, 'fetchPackageByCustomerId');

const getDataForUpgradesByProjectId = createAsyncActionTypes(domain, 'getDataForUpgradesByProjectId');

const upgradePackageRequest = createAsyncActionTypes(domain, 'upgradePackageRequest');

const revertUpgradeRequest = createAsyncActionTypes(domain, 'revertUpgradeRequest');

const requestExtensionFeePayment = createAsyncActionTypes(domain, 'requestExtensionFeePayment');

export default {
  fetchPackageByProjectId,
  fetchPackageByCustomerId,
  fetchPackageForProofByProjectId,
  getDataForUpgradesByProjectId,
  upgradePackageRequest,
  revertUpgradeRequest,
  requestExtensionFeePayment,
};
